import { render, staticRenderFns } from "./maintain.vue?vue&type=template&id=05fb2b8a&scoped=true"
import script from "./maintain.vue?vue&type=script&lang=js"
export * from "./maintain.vue?vue&type=script&lang=js"
import style0 from "./maintain.vue?vue&type=style&index=0&id=05fb2b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fb2b8a",
  null
  
)

export default component.exports